/**
 * Brazil's PROPOSAL for `central.contactMarket` (D853 phase A) - country-pack data, NOT seeded and NOT published: the owner publishes it in Admin under four eyes
 * (a change is a new version, never an edit of this file on a running market).
 *
 * The neutral key lives in `@vello/config`; what is Brazilian is only the area-code map. Each DDD (the two digits after the country code 55) lists the pilot markets
 * it makes LIKELY: `34` covers Patos de Minas (and also Uberlandia and Uberaba, which Vello does not serve), `38` covers Paracatu (and Montes Claros). It is a weak
 * signal - numbers are ported and people travel - so the setting forces `areaHints.orderOnly`: the prefix only puts the likely city first among the buttons and
 * never decides the city. Only SERVED markets are listed; a new city adds its DDD here as a new version.
 *
 * The rest is the neutral default the owner chose on 2026-10-30: the ride the contact is about beats the account's home city, the person's own answer closes the
 * list, ask once and once more before handing over to people, count the demand for a city we do not serve and offer "Avise-me" with an explicit marketing opt-in.
 * There is no IP-geolocation signal (owner decision 9).
 */
import { DEFAULT_CENTRAL_CONTACT_MARKET } from '@vello/config';
/** DDD (area code, digits after the calling code) -> the served markets it makes likely. */
export const BRAZIL_AREA_CODE_MARKETS = {
    '34': ['br:patos-de-minas'],
    '38': ['br:paracatu'],
};
/** v1 PROPOSAL (not published): the neutral default plus Brazil's area codes. */
export const BRAZIL_CONTACT_MARKET_V1_PROPOSAL = {
    ...DEFAULT_CENTRAL_CONTACT_MARKET,
    areaHints: { orderOnly: true, prefixes: BRAZIL_AREA_CODE_MARKETS },
};
//# sourceMappingURL=contact-market.js.map